import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import gradient from 'random-gradient';
import tinycolor from 'tinycolor2';
import initials from 'initials';
import styles from './styles.css';
import Spinner from '../spinner';

const initialsInNamePattern = /\(([^)]+)\)/;

function loadImage(url, user, auth) {
  if (!url) {
    return Promise.resolve(null);
  }
  return new Promise((resolve) => {
    let realUrl = url;
    if (realUrl.indexOf('http') === 0 && auth && user.organization_id === auth.organization_id && auth.access_token) {
      realUrl += `?oauth_token=${auth.access_token}`;
    }
    if (typeof window !== 'undefined') {
      const image = new window.Image();
      image.onload = () => {
        resolve(realUrl);
      };
      image.onerror = () => {
        resolve(null);
      };
      image.src = realUrl;
    } else {
      resolve(realUrl);
    }
  });
}


class Avatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      url: null,
      currentUrl: null,
    };
  }

  componentDidMount() {
    this.mounted = true;
    const photo = this.getPhotoUrl(this.props);
    if (!photo) {
      this.setState({ loading: false });
    }
    this.checkProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.checkProps(nextProps);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getPhotoUrl(props) {
    const { user } = props;
    if (!user || !user._id) {
      return null;
    }
    const photo = user.full_photo_url || user.medium_photo_url || user.small_photo_url || user.photo;
    // const photo = user.small_photo_url || user.medium_photo_url || user.full_photo_url || user.photo;
    return photo;
  }

  getName() {
    const { user } = this.props;
    return user.name || user.display_name;
  }

  getPallete() {
    const { user } = this.props;
    const id = user.user_id || user._id;
    const bg = gradient(id); // linear-gradient(to top right, #f9e806, #06f9e8)
    const parts = bg.split(', ');
    const primaryColor = parts.length === 3 ? parts[1] : null;
    const secondaryColor = parts.length === 3 ? parts[2].replace(')', '') : null;
    return [primaryColor, secondaryColor];
  }

  checkProps(props) {
    const { user, loginUser } = props;
    const { currentUrl } = this.state;
    const newPhoto = this.getPhotoUrl(props);
    if (currentUrl !== newPhoto) {
      this.setState({ loading: true, currentUrl: newPhoto });
      loadImage(newPhoto, user, loginUser).then((url) => {
        if (this.mounted) {
          this.setState({ loading: false, url });
        }
      });
    }
  }

  renderPhoto(url) {
    const style = {
      backgroundImage: `url(${url})`,
    };
    return (
      <div className={styles.photo} style={style} />
    );
  }

  renderInitial(name) {
    const { small } = this.props;
    const pallete = this.getPallete();
    const color = pallete[1];
    const color2 = pallete[0];
    const white = '#ffffff';
    const style = {
      backgroundColor: tinycolor.mix(color, white, 85).toHexString(),
    };

    const innerStyles = {
      color: tinycolor.mix(color2, white, 60).toHexString(),
    };
    const display = (name || '').replace(initialsInNamePattern,  '');
    return (
      <div className={`${styles.generic} generic-avatar`} style={style}>
        <div className={styles.initial}><div style={innerStyles}>{initials(display, { length: 2 })}</div></div>
      </div>
    );
  }

  render() {
    const {
      user, isTooltip, className, size,
      small,
    } = this.props;
    const { loading, url } = this.state;
    if (!user) {
      return null;
    }
    const name = this.getName();
    const cls = classNames([
      styles.mediaObject,
      loading ? styles.mediaObjectLoading : null,
      className,
      small ? styles.small : null,
    ]);
    if (isTooltip) {
      return (
        <div className={cls}>
          {this.renderPhoto(this.getPhotoUrl(this.props))}
        </div>
      );
    }
    return (
      <div className={cls}>
        {loading && <Spinner autoSize />}
        {!loading && url !== null && url !== undefined && this.renderPhoto(url)}
        {!loading && !url && this.renderInitial(name)}
      </div>
    );
  }
}

Avatar.propTypes = {
  user: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
  isTooltip: PropTypes.bool,
  size: PropTypes.number,
  small: PropTypes.bool,
};
Avatar.defaultProps = {
  user: null,
  isTooltip: false,
  className: null,
  size: 50,
  small: false,
};
export default Avatar;
